import { Injectable } from "@angular/core";
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { of } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { AuthRedirectService, WindowRef } from "@spartacus/core";
import { UIGMultiSiteService } from "../uig-multi-site.service";
@Injectable()
export class UIGBaseSiteResponseInterceptor implements HttpInterceptor {
  private readonly forceHomeAfterBaseSiteSwitchKey = "uig.forceHomeAfterBaseSiteSwitch";

  constructor(
    private uigMultiSiteService: UIGMultiSiteService,
    private authRedirectService: AuthRedirectService,
    private winRef: WindowRef
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      switchMap((event) => {
        if (
          event instanceof HttpResponse &&
          event.headers.get("X-Basesite-Changed") === "true"
        ) {
          const targetBaseSite = event.headers.get("X-Target-Basesite");
          const targetLanguage = event.headers.get("X-Target-Language");

          if (!targetBaseSite || !targetLanguage) {
            return of(event);
          }

          return this.uigMultiSiteService
            .switchSite(
              targetBaseSite,
              targetLanguage,
            )
            .pipe(
              map(() => event)
            );
        }

        return of(event);
      })
    );
  }

}
